import WaitingDots from "components/WaitingDots";
import { useOfficeTranslation } from "i18n/OfficeTranslation";
import { Email } from "models/Email";
import { Invoice } from "models/Invoice";
import React, { useEffect, useState } from "react";
import { Alert, Card, CardBody } from "reactstrap";
import * as api from "services/Api";
import EmailRowInbox from "../Email/EmailRowInbox";

interface Props {
    invoice: Invoice;
}

const InvoiceEmails: React.FC<Props> = ({ invoice }) => {
    const { t } = useOfficeTranslation();
    const [emails, setEmails] = useState<Email[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const reference = `invoice_${invoice.id}`;

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError("");
        setEmails([]);

        api.getEmailsByReference(reference)
            .then(items => {
                if (!active) return;
                setEmails((items ?? [])
                    .filter(email => email.direction === "out" && email.reference === reference)
                    .sort((a, b) => b.date - a.date));
            })
            .catch(() => {
                if (active) {
                    setError(t("invoice.invoiceEmails.sentMailsCouldNotBeLoaded"));
                }
            })
            .finally(() => {
                if (active) {
                    setLoading(false);
                }
            });

        return () => {
            active = false;
        };
    }, [reference, t]);

    return (
        <Card>
            <CardBody>
                <h5 className="invoice-section-title d-flex justify-content-between">{t("invoice.invoiceEmails.sentMails")}{!loading && !error && <span className="badge bg-light text-muted">{emails.length}</span>}</h5>

                {loading && <WaitingDots />}
                {!loading && error && <Alert color="danger" className="mb-0">{error}</Alert>}
                {!loading && !error && <ul className="invoice-email-list mb-0">
                    {emails.map(email => (
                        <EmailRowInbox key={email.id} email={email} hideLabels={true} compact onStarChange={updated => setEmails(items => items.map(item => item.id === updated.id ? updated : item))} />
                    ))}
                    {emails.length === 0 &&
                        <li className="text-muted">{t("common.noConversationsFound")}</li>
                    }
                </ul>}
            </CardBody>
        </Card>
    );
};

export default InvoiceEmails;
